
import axios from "axios";

const uberEatsURL = 'https://api.uber.com/v1/';

export const uber_eats_base_api = axios.create({
    // baseURL: process.env["REACT_APP_UBER_EATS_SERVER_BASE_URL"],
    baseURL: uberEatsURL,
  });